import '@/styles/globals.css';
import type { AppProps } from 'next/app';
import MainLayout from '@/components/Layouts/MainLayout';
import { useRouter } from 'next/router';
import Head from 'next/head';
import React, { ReactElement, ReactNode } from 'react';
import { NextPage } from 'next';

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
    getLayout?: (page: ReactElement) => ReactNode;
};

interface Props extends AppProps {
    Component: NextPageWithLayout;
}

export default function App({ Component, pageProps }: Props) {
    const router = useRouter();
    const pageKey = router.asPath;

    const getLayout = Component.getLayout || ((page: React.ReactNode) => page);

    return (
        <MainLayout>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1"
                />
            </Head>
            {getLayout(<Component key={pageKey} {...pageProps} />)}
        </MainLayout>
    );
}
